import { z } from 'zod';
import { blockSchema } from './block.js';

var QuestionType = /* @__PURE__ */ ((QuestionType2) => {
  QuestionType2["MCQ"] = "MCQ";
  QuestionType2["MSQ"] = "MSQ";
  QuestionType2["POLL"] = "POLL";
  QuestionType2["WORDCLOUD"] = "WORDCLOUD";
  QuestionType2["BLANK"] = "BLANK";
  QuestionType2["OPEN"] = "OPEN";
  QuestionType2["DRAW"] = "DRAW";
  QuestionType2["AUDIO"] = "AUDIO";
  QuestionType2["VIDEO"] = "VIDEO";
  QuestionType2["MATCH"] = "MATCH";
  QuestionType2["REORDER"] = "REORDER";
  QuestionType2["DRAGNDROP"] = "DRAGNDROP";
  QuestionType2["DROPDOWN"] = "DROPDOWN";
  QuestionType2["EQUATION"] = "EQUATION";
  QuestionType2["DND_IMAGE"] = "DND_IMAGE";
  QuestionType2["HOTSPOT"] = "HOTSPOT";
  QuestionType2["GRAPHING"] = "GRAPHING";
  QuestionType2["CLASSIFICATION"] = "CLASSIFICATION";
  QuestionType2["COMPREHENSION"] = "COMPREHENSION";
  QuestionType2["COMPREHENSION_VIDEO"] = "COMPREHENSION_VIDEO";
  QuestionType2["SLIDEV2"] = "SLIDEV2";
  return QuestionType2;
})(QuestionType || {});
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["ASCENDING"] = "asc";
  OrderType2["DESCENDING"] = "desc";
  return OrderType2;
})(OrderType || {});
const baseSettingsSchema = z.object({
  hasCorrectAnswer: z.boolean().optional(),
  fibDataType: z.union([z.string(), z.number()]).optional().nullable(),
  canSubmitCustomResponse: z.boolean().optional().nullable(),
  doesOptionHaveMultipleTargets: z.boolean().optional().nullable(),
  questionDisplayVariant: z.string().optional().nullable(),
  ignoreAccentMarksForEvaluation: z.boolean().optional().nullable(),
  enableAccentMarks: z.boolean().optional().nullable(),
  questionMetadata: z.object({}).optional().nullable(),
  // TODO @QAbhishekKumar fix types in graphing and shared-domain
  graphData: z.any().optional().nullable()
});
const baseTargetSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  position: z.object({
    x: z.union([z.string(), z.number()]),
    y: z.union([z.string(), z.number()])
  }).optional()
});
const baseStructureSchema = z.object({
  kind: z.nativeEnum(QuestionType),
  settings: baseSettingsSchema,
  marks: z.object({
    correct: z.number(),
    incorrect: z.number()
  }),
  hasMath: z.boolean().default(false).nullable(),
  query: blockSchema,
  options: z.array(blockSchema),
  matches: z.array(blockSchema).optional(),
  order: z.nativeEnum(OrderType).optional(),
  targets: z.array(baseTargetSchema).optional(),
  answer: z.any(),
  explain: blockSchema.nullable(),
  hints: z.array(blockSchema),
  graphs: z.array(z.any()).optional()
});
const baseAnswerSchema = z.object({
  targetId: z.string(),
  optionId: z.array(z.string())
});

export { OrderType, QuestionType, baseAnswerSchema, baseSettingsSchema, baseStructureSchema, baseTargetSchema };
